<template>
  <base-material-card :icon="resource.icon" :title="title">
    <va-aside-layout :title="asideTitle">
      <scopes-show v-if="show" :item="item"></scopes-show>
      <scopes-edit v-if="edit || create" :id="id" :key="formKey" :item="item" @saved="onSaved"></scopes-edit>
    </va-aside-layout>
    <va-list
      ref="list"
      disable-export
      disable-global-search
      disable-create-redirect
      disable-query-string
      cursor-pagination
      :items-per-page="300"
      :items-per-page-options="[50, 100, 200, 300, 400]"
      @action="onAction"
    >
      <va-data-table
        :fields="fields"
        disable-create-redirect
        disable-show-redirect
        disable-edit-redirect
        disable-clone
        @item-action="onAction"
      >
        <template #[`field.scopes`]="{ value }">
          <base-Scopes-selector :scopes="value" small />
        </template>
      </va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
export default {
  props: {
    resource: { type: Object, default: null },
    title: { type: String, default: '' },
  },
  data() {
    return {
      fields: [{ source: 'id', sortable: true }, 'scopes'],
      asideTitle: null,
      id: null,
      item: null,
      show: false,
      edit: false,
      create: false,
      formKey: 1, // just to fix stupid problem with aside create form dont open second time if props are same
    };
  },
  methods: {
    async onAction({ action, title, id, item }) {
      this.formKey += 1;
      this.asideTitle = title;
      this.id = id;
      this.show = action === 'show';
      this.edit = action === 'edit';
      this.create = action === 'create';
      this.item = item;
    },
    onSaved() {
      this.asideTitle = null;
      this.$refs.list.fetchData();
    },
  },
};
</script>
